import React from 'react';
import { XIcon, BrainIcon, ArrowRightIcon } from 'lucide-react';
const QuizExitPopup = ({
  isVisible,
  onClose,
  onContinue
}) => {
  if (!isVisible) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 animate-fadeIn" data-id="element-80">
      <div className="bg-white rounded-xl max-w-md w-full p-6 relative shadow-2xl" data-id="element-81">
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-82">
          <XIcon className="h-5 w-5" data-id="element-83" />
        </button>
        <div className="text-center mb-5" data-id="element-84">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-50 rounded-full mb-4" data-id="element-85">
            <BrainIcon className="h-8 w-8 text-blue-600" data-id="element-86" />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-87">Vänta!</h2>
          <p className="text-gray-600 mb-3" data-id="element-88">
            Du är bara några frågor från att upptäcka vad som påverkar ditt
            minne och hur du kan förbättra det.
          </p>
        </div>
        <div className="bg-blue-50 rounded-lg p-4 mb-5 border border-blue-100" data-id="element-89">
          <p className="text-sm text-blue-800" data-id="element-90">
            <span className="font-semibold" data-id="element-91">Visste du att:</span> 83% av
            deltagarna upptäcker en specifik orsak till deras minnesförsämring
            som de aldrig tänkt på tidigare. Dina personliga resultat kan vara
            nyckeln till ett bättre minne.
          </p>
        </div>
        <div className="mb-5" data-id="element-92">
          <button onClick={onContinue} className="w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-all duration-300 transform hover:scale-105 pulse-button flex items-center justify-center" data-id="element-93">
            Fortsätt testet och få dina resultat
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-94" />
          </button>
        </div>
        <div className="text-center" data-id="element-95">
          <button onClick={onClose} className="text-sm text-gray-500 hover:text-gray-700 hover:underline" data-id="element-96">
            Nej tack, jag vill inte veta vad som påverkar mitt minne
          </button>
        </div>
      </div>
    </div>;
};
export default QuizExitPopup;